export const NO_DURATION = 'PT0S';
